export const feedbackForms = {
  home: {
    title: "Feedback",
    subtitle: "Start a form, open one you already have, or read what people sent back.",
    back: "All feedback",
    newForm: "New form",
    newFormDescription: "Set up questions, triangles, and a share link.",
    existingForms: "Existing forms",
    existingFormsDescription: "Open a form, copy its link, or show a QR code.",
    responses: "Responses",
    responsesDescription: "Read what people have filled in.",
  },
  list: {
    editForm: "Edit form",
    duplicateForm: "Duplicate form",
    deleteForm: "Delete form",
  },
  share: {
    title: "Share form",
    open: "Share",
    description: "Anyone with this link or QR code can open the form and fill it in.",
    copyLink: "Copy link",
    copyPassword: "Copy password",
    copied: "Copied",
    downloadQr: "Download QR",
    preparingQr: "Preparing QR…",
    qrFailed: "Could not create the QR code. Please try again.",
    passwordLabel: "Password",
    passwordHint: "Share this with people filling the form in.",
    inactive: "Turn the form on before sharing a link.",
  },
  password: {
    heading: "Form access",
    label: "Enter the password to open this form",
    incorrect: "That password is incorrect. Please try again.",
    required: "Please enter the password to continue."
  },
  conditionalLogic: {
    title: "Conditional Logic",
    description: "Enable conditional logic to show this question only when specific conditions are met.",
    enabled: "Enable conditional logic",
    disabled: "Conditional logic disabled",
    noPreviousQuestions: "No previous questions available for conditional logic. Add questions before this one to create conditions.",
    combineRules: "Combine rules with",
    andOperator: "AND (all conditions must be true)",
    orOperator: "OR (any condition can be true)",
    addCondition: "Add Condition",
    question: "Question",
    operator: "Operator",
    value: "Value",
    operators: {
      equals: "Equals",
      notEquals: "Does not equal",
      contains: "Contains",
      notContains: "Does not contain",
      greaterThan: "Greater than",
      lessThan: "Less than",
      selected: "Is selected",
      notSelected: "Is not selected"
    }
  },
  rating: {
    both: "A bit of both",
  },
  triad: {
    instructions: "Click within the triangle to indicate your position. The centre represents equal amounts of all three; closer to a corner means stronger alignment with that point.",
    none: "None of the above"
  },
  aggregated: {
    markCountOne: "1 mark",
    markCount: "{{count}} marks",
  },
  renderer: {
    success: {
      title: "Thank you for your feedback!",
      message: "Your response has been recorded successfully.",
      previewMessage: "(This is a preview - no actual data was saved)"
    },
    error: {
      contactAdmin: "If you believe this is an error, please contact the form administrator."
    },
    submit: {
      submitting: "Submitting...",
      defaultButtonText: "Submit"
    },
    downloadApp: {
      title: "Download the OVERHEAR app"
    }
  }
}
